export default {
    ProjectName: 'Tên dự án',
    ProjectCode: 'Mã dự án',
    SoCKC: 'Số CKC, HĐTH',
    PaymentOfferNo: 'Căn cứ Giấy đề nghị thanh toán vốn đầu tư số',
    Date: 'Ngày',
    NamKHV: 'Năm KHV',
    SoCKCTitle: 'Số cam kết chi, Hợp đồng thực hiện',
    NamKHVTitle: 'Năm kế hoạch vốn'
};
